module.exports = __webpack_public_path__ + "img/photo-20.13044796.jpg";